module.exports = __webpack_public_path__ + "static/media/SL-pencil.bb42a9d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/SL-pencil.svg
// module id = 207
// module chunks = 1